// this file is automatically generated by git.version.ts script
export const versions = {commit: '0928acc1', tag: '2026.4.002-RELEASE'};
